import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Typography } from 'antd';
import ButtonWithIcon from '../../../../../utils/components/ButtonWithIcon/ButtonWithIcon'
import './ScreenHome.css'
import { MailFilled } from '@ant-design/icons';
import CustomIcon from '../../../../../utils/components/CustomIcon/CustomIcon';

const { Title } = Typography;

const ScreenHome = ({ activeStep = 1 }) => {
  const history = useHistory()

  return (
    <div id="screen-container">
      {activeStep === 1 && (
        <>
          <Title level={1} style={{ margin: 0 }}>Welcome to GENA Screen</Title>
          <Title level={3} style={{ margin: 0, color: '#D65C5C' }}>Empowering clinicians with accurate, real-time decision support</Title>
        </>
      )}
      {activeStep === 2 && <Title level={1} style={{ margin: 0 }}>Searching...</Title>}
      <div className="step-indicator-wrapper">
        <div className="step-indicator-container">
          <div className={activeStep === 1 ? "step-indicator-active" : "step-indicator"}>1</div>
          <div>Enter Symptoms</div>
        </div>
        <div className="step-indicator-container">
          <div className={activeStep === 2 ? "step-indicator-active" : "step-indicator"}>2</div>
          <div>AI Analysis</div>
        </div>
        <div className="step-indicator-container">
          <div className={activeStep === 3 ? "step-indicator-active" : "step-indicator"}>3</div>
          <div>Request a Test</div>
        </div>
      </div>
      <Button href="/contact-us">
        Contact Us
        <CustomIcon name="Mail" />
      </Button>
      {/* <ButtonWithIcon iconName="Mail-Black" buttonProps={{ onClick: () => history.push('/contact-us') }}>
        Contact Us
      </ButtonWithIcon> */}
    </div>
  );
};

export default ScreenHome;
